import { render, staticRenderFns } from "./selectFeeConfig.vue?vue&type=template&id=0cf4e334&scoped=true"
import script from "./selectFeeConfig.vue?vue&type=script&lang=js"
export * from "./selectFeeConfig.vue?vue&type=script&lang=js"
import style0 from "./selectFeeConfig.vue?vue&type=style&index=0&id=0cf4e334&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf4e334",
  null
  
)

export default component.exports